import { render, staticRenderFns } from "./ResponsiveBackground.vue?vue&type=template&id=66a9020a&scoped=true&"
import script from "./ResponsiveBackground.vue?vue&type=script&lang=js&"
export * from "./ResponsiveBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a9020a",
  null
  
)

export default component.exports